import { registerLicense } from '@syncfusion/ej2-base';
registerLicense(environment.syncFusionKey);
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import posthog from 'posthog-js'

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error(err);
  });

posthog.init(
  environment.posthogKey,
  {
    api_host: environment.posthogHost,
    person_profiles: 'identified_only',
    defaults: '2025-05-24'
  }
)
